import { z } from 'zod';


const createFractionalLeaveAssignmentBaseSchema = z.object({
  employeeTargetId: z.union([
    z.coerce
      .number({ invalid_type_error: 'absence:fractionalLeave.validation.employeeRequired' })
      .int()
      .positive('absence:fractionalLeave.validation.employeeRequired'),
    z.null(),
  ]),
  fractionalLeaveTypeId: z.union([
    z.coerce
      .number({ invalid_type_error: 'absence:fractionalLeave.validation.fractionalLeaveTypeRequired' })
      .int()
      .positive('absence:fractionalLeave.validation.fractionalLeaveTypeRequired'),
    z.null(),
  ]),
  startDate: z
    .string()
    .min(1, 'absence:fractionalLeave.validation.startDateRequired')
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'absence:fractionalLeave.validation.invalidDateFormat'),
  hoursToJustify: z
    .string()
    .min(1, 'absence:fractionalLeave.validation.hoursToJustifyRequired')
    .regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'absence:fractionalLeave.validation.hoursToJustifyInvalidFormat'),
  detail: z
    .union([z.string().max(100, 'absence:fractionalLeave.validation.detailMaxLength'), z.null()])
    .optional()
    .default(null)
    .transform((value) => value ?? ''),
});

export const createFractionalLeaveAssignmentFormSchema = createFractionalLeaveAssignmentBaseSchema
  .refine((data) => data.employeeTargetId !== null, {
    message: 'absence:fractionalLeave.validation.employeeRequired',
    path: ['employeeTargetId'],
  })
  .refine((data) => data.fractionalLeaveTypeId !== null, {
    message: 'absence:fractionalLeave.validation.fractionalLeaveTypeRequired',
    path: ['fractionalLeaveTypeId'],
  });

export type CreateFractionalLeaveAssignmentFormValues =
  z.infer<typeof createFractionalLeaveAssignmentFormSchema>;
